import type React from 'react';

import cn from 'classnames';

import * as st from './styles.module.scss';

interface Props {
	isNow: boolean;
	blockType?: string;
	children?: React.ReactNode;
}

export const SessionContent: React.FC<Props> = ({ isNow, blockType = 'single', children }) => {
	return (
		<div className={cn(st.content, st[blockType], isNow && st.now)}>
			{(blockType === 'start' || blockType === 'start_topOverlap' || blockType === 'single') &&
				children}
		</div>
	);
};
